export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7689.a395b3b3.jpg";